<div name="logout-callback" attr.data-env="{{env}} | {{build}}" class="d-flex align-items-center">
  <!-- <i class="jr-icon loading jr-spin mr-1"></i> Logout Callback -->
</div>
